import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import des fichiers de traduction par langue et par page
// Français
import frSkills from './locales/fr/skills.json';
import frPortfolio from './locales/fr/portfolio.json';
import frNavbar from './locales/fr/navbar.json';
import frHome from './locales/fr/home.json';
import frFooter from './locales/fr/footer.json';
import frEducation from './locales/fr/education.json';
import frContact from './locales/fr/contact.json';
import frCommon from './locales/fr/common.json';
import frCareer from './locales/fr/career.json';
import frCV from './locales/fr/cv.json';

// Anglais
import enSkills from './locales/en/skills.json';
import enPortfolio from './locales/en/portfolio.json';
import enNavbar from './locales/en/navbar.json';
import enHome from './locales/en/home.json';
import enFooter from './locales/en/footer.json';
import enEducation from './locales/en/education.json';
import enContact from './locales/en/contact.json';
import enCommon from './locales/en/common.json';
import enCareer from './locales/en/career.json';
import enCV from './locales/en/cv.json';

// Construction des ressources de traduction modulaires
const resources = {
  fr: {
    skills: frSkills,
    portfolio: frPortfolio,
    navbar: frNavbar,
    home: frHome,
    footer: frFooter,
    education: frEducation,
    contact: frContact,
    common: frCommon,
    career: frCareer,
    cv: frCV
  },
  en: {
    skills: enSkills,
    portfolio: enPortfolio,
    navbar: enNavbar,
    home: enHome,
    footer: enFooter,
    education: enEducation,
    contact: enContact,
    common: enCommon,
    career: enCareer,
    cv: enCV
  }
};

i18n
  // Permet de charger les traductions à partir du serveur
  .use(Backend)
  // Détecte la langue de l'utilisateur
  .use(LanguageDetector)
  // Intègre i18next avec React
  .use(initReactI18next)
  // Initialise i18next
  .init({
    resources,
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // Ne pas échapper les valeurs HTML
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    // Utilisation de l'espace de noms pour accéder aux différents fichiers de traduction
    ns: ['skills', 'portfolio', 'navbar', 'home', 'footer', 'education', 'contact', 'common', 'career', 'cv'],
    defaultNS: 'common'
  });

// Force la langue française au démarrage uniquement si aucune langue n'est définie
if (!localStorage.getItem('i18nextLng')) {
  i18n.changeLanguage('fr');
}

export default i18n;